


































































import AppCenter from "../../widget/AppCenter.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import {
  CustomersApi,
  GetCustomersResponse,
  GetLocationsCustomerResponse,
  LocationsApi,
  ApiMessage,
  LicensesApi,
  WebConfigsApi,
} from "../../../apis/index";
import { AxiosResponse } from "axios";
import { Dictionary } from "lodash";
import moment from "moment";

@Component({
  components: { ValidationObserver, ValidationProvider, AppCenter },
})
export default class EditWebConfig extends Vue {
  webConfig: any = {};
  previewImage: any = null;
  previewImage2: any = null;
  async created() {
    this.$util.showLoading();
    try {
      const res = await new WebConfigsApi().getDefaultWebConfig();
      this.webConfig = res.data.data;
      this.previewImage = this.webConfig.foreignStamp;
      this.previewImage2 = this.webConfig.domesticStamp;
    } catch (error) {
      this.$util.showError(error);
      return;
    } finally {
      this.$util.hideLoading();
    }
  }
 uploadImage(event){
  const image = event.target.files[0];
  const reader = new FileReader();
  reader.readAsDataURL(image);
  reader.onload = (e) => {
    this.previewImage = e.target['result'];
  };
  }
 uploadImage2(event){
  const image = event.target.files[0];
  const reader = new FileReader();
  reader.readAsDataURL(image);
  reader.onload = (e) => {
    this.previewImage2 = e.target['result'];
  };
  }

  async onSubmit() {
    this.$util.showLoading();
    await this.doSubmit()
      .then((res) => this.handleSuccess())
      .catch((err) => this.handleFailed(err));
    this.$util.hideLoading();
  }

  async doSubmit() {
    try {
      this.webConfig.foreignStamp =  this.previewImage;
      this.webConfig.domesticStamp =  this.previewImage2;
      const res = await new WebConfigsApi().updateDefaultWebConfig({
        webConfigRequest: this.webConfig,
      });
    } catch (error) {
      this.$util.showError(error);
      return;
    }
  }

  getRouteCancel() {
    this.$router.push({ name: "edit-webconfig" });
  }

  handleSuccess() {
    this.getRouteCancel();
  }

  handleFailed(err) {
    this.$util.showError(err);
  }
}
